import { notification } from 'antd';
import { all, call, put, take } from 'redux-saga/effects';
// import { notifyMessageAction } from 'store/notification/action';
// import { history } from 'store';
import {
  SEND_VERIFICATION_CODE,
  VERIFY_CODE,
  UPLOAD_PATIENT_SIGNATURE,
} from '../type';
import {
  sendVerificationCodeSuccessAction,
  sendVerificationCodeErrorAction,
  verifyCodeSuccessAction,
  verifyCodeErrorAction,
  uploadPatientSignatureSuccessAction,
  uploadPatientSignatureErrorAction,
} from '../action';

import { onsiteBookingService } from 'services';

function* sendVerificationCode() {
  while (1) {
    const action = yield take(SEND_VERIFICATION_CODE);
    try {
      const sendingVerificationResponse = yield call(
        onsiteBookingService.sendVerificationCode,
        action.payload,
      );
      yield put(sendVerificationCodeSuccessAction(sendingVerificationResponse));
      notification.success({
        message: 'Verification code has been sent to request email !',
      });
    } catch (err) {
      notification.error({
        message: err.message,
      });
      yield put(sendVerificationCodeErrorAction(err));
    }
  }
}

function* verifyCode() {
  while (1) {
    const action = yield take(VERIFY_CODE);
    try {
      const verifyingCodeResponse = yield call(
        onsiteBookingService.verifyCode,
        action.payload,
      );

      notification.success({
        message: 'Verified. Please keep scrolling down to complete booking.',
      });
      if (action.payload.callback) {
        action.payload.callback();
      }
      yield put(verifyCodeSuccessAction(verifyingCodeResponse));
    } catch (err) {
      notification.error({
        message: err.message,
      });
      yield put(verifyCodeErrorAction(err));
    }
  }
}

function* uploadPatientSignature() {
  while (1) {
    const action = yield take(UPLOAD_PATIENT_SIGNATURE);
    const { fileExtension, base64Data, callback } = action.payload;
    const binaryData = new Buffer(
      base64Data.replace(/^data:image\/\w+;base64,/, ''),
      'base64',
    );
    try {
      const uploadDataInfo = yield call(onsiteBookingService.getUploadData, {
        fileExtension,
      });

      const { rawUrl } = uploadDataInfo;
      yield call(onsiteBookingService.uploadSignature, {
        rawUrl,
        data: binaryData,
      });
      yield put(uploadPatientSignatureSuccessAction(uploadDataInfo));
      if (callback) {
        callback(uploadDataInfo);
      }
    } catch (err) {
      notification.error({
        message: err.message,
      });
      yield put(uploadPatientSignatureErrorAction(err));
    }
  }
}

export default function* rootSaga() {
  yield all([sendVerificationCode(), verifyCode(), uploadPatientSignature()]);
}
